import { render, staticRenderFns } from "./SixMonthOrange.vue?vue&type=template&id=dacfb816&scoped=true&"
import script from "./SixMonthOrange.vue?vue&type=script&lang=js&"
export * from "./SixMonthOrange.vue?vue&type=script&lang=js&"
import style0 from "./SixMonthOrange.vue?vue&type=style&index=0&id=dacfb816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacfb816",
  null
  
)

export default component.exports